const requisites = {
    namespaced: true,
    state: () => ({
        requisiteTypes: [
            { id: 0, value: "Текст" },
            { id: 1, value: "Логический" },
            { id: 2, value: "Дата" },
            { id: 3, value: "Сотрудник" },
            { id: 4, value: "Организация" }
        ],
        search: null,
        tableOptions: {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "name" ],
            sortDesc : [ false ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
    }),
    mutations: {
        SET_SEARCH (state, payload) {
            state.search = payload;
            state.tableOptions.page = 1;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
    },
    getters: {
        getRequisiteTypes: (s) => s.requisiteTypes,
        getSearch: (s) => s.search,
        getTableOptions (state) {
            return state.tableOptions;
        }
    }
}

export default requisites;